import { Badge } from '@/components/ui/badge';
import { cn } from '@/helpers/shadcn';

const STATUS_STYLES = {
  'To Do': 'border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200',
  'In Progress': 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-300',
  'In Review': 'border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-900 dark:bg-indigo-950 dark:text-indigo-300',
  Idle: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-300',
  Idea: 'border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-900 dark:bg-violet-950 dark:text-violet-300',
  Icebox: 'border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900 dark:bg-sky-950 dark:text-sky-300',
  Done: 'border-green-200 bg-green-50 text-green-700 dark:border-green-900 dark:bg-green-950 dark:text-green-300',
  Archived: 'border-border bg-muted text-muted-foreground'
};

const StatusBadge = ({ status, children, className }) => {
  return (
    <Badge variant="outline" className={cn('whitespace-nowrap font-medium', STATUS_STYLES[status], className)}>
      {children ?? status}
    </Badge>
  );
};

export default StatusBadge;
